const answerFor = (a, key) => a[key.replace(/_(any|in)$/, "")];

export function matches(when = {}, a) {
  return Object.entries(when).every(([k, vals]) => {
    const v = answerFor(a, k);
    return Array.isArray(v) ? v.some((x) => vals.includes(x)) : vals.includes(v);
  });
}

const applies = (b, a) => matches(b.when, a) && !(b.unless && matches(b.unless, a));

export const makeEmpty = (j) => Object.fromEntries([
  ...(j.safety_question ? [["safety", null]] : []),
  ...j.questions.map((q) => [q.id, q.type === "multi" ? [] : null]),
]);

const SAFETY_ORDER = ["yes", "selfharm", "abuse", "child", "unsure"];
const isSelected = (v, value) => (Array.isArray(v) ? v.includes(value) : v === value);

export function safetyKinds(j, a, onlyIds) {
  const kinds = [];
  const include = (id) => !onlyIds || onlyIds.includes(id);
  if (j.safety_question && include("safety") && ["yes", "unsure"].includes(a.safety)) kinds.push(a.safety);
  j.questions.filter((q) => include(q.id)).forEach((q) =>
    q.options.forEach((o) => { if (o.safety && isSelected(a[q.id], o.value)) kinds.push(o.safety); }));
  return SAFETY_ORDER.filter((k) => kinds.includes(k));
}

const HEAVY = ["overwhelmed", "selfharm", "exhausted"];

export function buildPlan(j, answers, { neutral = false } = {}) {
  const a = { ...answers, need: answers.need || j.default_need };
  const person = j.person_terms[neutral ? "skip" : a.relationship || "skip"];
  const f = (t) => t.replaceAll("{person}", person);
  const rank = (list) => (list || []).filter((b) => applies(b, a)).sort((x, y) => (y.priority || 0) - (x.priority || 0));
  const texts = (list, max) => [...new Set(rank(list).map((b) => f(b.text)))].slice(0, max);
  const slugs = (rules) => [...new Set(rank(rules).map((r) => r.slug))];
  const heavy = Object.values(a).flat().some((v) => HEAVY.includes(v));
  const override = rank(j.next_step_overrides)[0];
  const step = override ? override.step : j.next_steps[a.need] || Object.values(j.next_steps)[0];
  const kinds = safetyKinds(j, a);
  return {
    ack: heavy ? j.results.ack_overwhelmed : j.results.ack,
    today: { ...step, text: f(step.text) },
    matters: texts(j.blocks.matters, heavy ? 2 : 3),
    actions: texts(j.blocks.actions, 3),
    wait: texts(j.blocks.wait, 3),
    youMatter: texts(j.blocks.you_matter, 1)[0],
    notes: texts(j.blocks.notes, 2),
    articles: slugs(j.article_rules).map((s) => j.articles_catalog.find((x) => x.slug === s)).filter(Boolean).slice(0, j.max_articles || 4),
    services: slugs(j.service_rules).map((s) => j.services_catalog.find((x) => x.slug === s)).filter(Boolean).slice(0, j.max_services || 4),
    related: slugs(j.related_rules).filter((s) => s !== j.slug).map((s) => (j.related_catalog || []).find((x) => x.slug === s)).filter(Boolean).slice(0, 2),
    supportFirst: a.need === "talk" || heavy || kinds.includes("selfharm"),
    safety: kinds,
  };
}

export const concernLabels = (j, a) =>
  j.questions.filter((q) => q.type === "multi")
    .flatMap((q) => q.options.filter((o) => !o.safety && (a[q.id] || []).includes(o.value)).map((o) => o.label));
